import { Layout } from "./components/Layout";
import { PopupContextProvider } from "./contexts/PopupContext";
import { QuoteControllerContextProvider } from "./contexts/QuoteControllerContext";
import Home from "./components/Home";

const App = () => {
    return (
        <Layout>
            <QuoteControllerContextProvider>
                <PopupContextProvider>
                    <Home />
                    {/*  <div className="text-quote-section dynamic-margin">*/}
                    {/*      <div id="get-quote-container">*/}
                    {/*          <div id="get-quote-content">*/}
                    {/*            <ShowQuote />*/}
                    {/*          </div>*/}
                    {/*      </div>*/}
                    {/*  </div>*/}
                </PopupContextProvider>
            </QuoteControllerContextProvider>
        </Layout>
    );
};

export default App;
